import React from 'react'
import { Spin } from 'antd'
import { useSelector } from 'react-redux'
import CommonTable from '../../components/CommonTable'

const ServiceDetails = () => {
  const { services, isLoading } = useSelector((state) => state.services)

  const columns = [
    {
      title: 'Service Name',
      dataIndex: 'serviceName',
      key: 'serviceName',
    },
    {
      title: 'Service Server',
      dataIndex: 'serviceServer',
      key: 'serviceServer',
    },
    {
      title: 'Path',
      dataIndex: 'path',
      key: 'path',
      ellipsis: true,
    },
    {
      title: 'Timing',
      dataIndex: 'timing',
      key: 'timing',
    },
    {
      title: 'Service Type',
      dataIndex: 'serviceType',
      key: 'serviceType',
    },
    {
      title: 'Port',
      dataIndex: 'port',
      key: 'port',
      width: 80,
    },
    {
      title: 'Protocol',
      dataIndex: 'protocol',
      key: 'protocol',
      width: 100,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 100,
    },
  ]

  if (isLoading) {
    return <Spin size="large" />
  }

  if (!services || services.length === 0) {
    return <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>No data available</div>
  }

  return (
    <CommonTable
      columns={columns}
      dataSource={services}
      rowKey="serviceId"
    />
  )
}

export default ServiceDetails
